/* eslint-disable */
import React, { Component } from 'react';

// Components and others
import PropTypes from 'prop-types';
import { clone } from 'lodash';
import ZipUtils from 'utils/ZipUtils';
import DateUtils from 'lib/DateUtils';
import update from 'immutability-helper';
import ModalUtils from 'utils/ModalUtils';
import StringUtils from 'lib/StringUtils';
import { DefaultCountry } from 'utils/enum/Customer';

// GraphQL
import CustomerMap from 'services/mapData/CustomerMap';
import GraphqlClient from 'services/apollo/GraphQLClient';
import CustomerService from 'services/modules/CustomerService';
import CustomerQuery from 'services/graphQL/query/CustomerQuery';

const CreateCustomerContainer = (WrappedComponent) => class extends Component {
    constructor(props) {
        super(props);

        const newRecord = this.getInitState();
        const cities = [];
        if (newRecord && newRecord.city) {
            cities.push(newRecord.city);
        }

        this.graphqlClient = new GraphqlClient();
        this.customerService = new CustomerService();
        this.state = {
            zipData: [],
            record: newRecord,
            listCity: cities,
            openConfirm: false,
            isDecoderEnabled: false,
            isDecodingZip: false,
            openModalSuggestedCustomer: false,
            suggestedCustomer: null,
            loadingSuggestedCustomer: false,
            createDespiteDuplicates: false,
        };

        this.initBind();
    }

    onEnableDecoder() {
        const { state: { isDecoderEnabled } } = this;
        if (!isDecoderEnabled) {
            this.setState({ isDecoderEnabled: true });
        }
    }





    onChangeValue(field, value, section = 'generalInfo') {
        this.setState(({ record }) => {
            const newRecord = { ...record };
            newRecord[section][field] = value;
            return { record: newRecord };
        }, () => {
            if (field === 'zipCode' && value.length === 5) {
                const { state: { isDecoderEnabled } } = this;
                if (isDecoderEnabled) {
                    this.decodeZip(value, section);
                }
            }
        });
    }

    onChangeLicenseData(licenseData) {
        this.setState(({ record }) => {
            const newRecord = { ...record };

            if (licenseData.firstName) newRecord.generalInfo.firstName = licenseData.firstName;
            if (licenseData.middleName) newRecord.generalInfo.middleName = licenseData.middleName;
            if (licenseData.lastName) newRecord.generalInfo.lastName = licenseData.lastName;
            if (licenseData.dob) newRecord.generalInfo.dob = licenseData.dob;
            if (licenseData.dln) newRecord.generalInfo.dln = licenseData.dln;
            if (licenseData.address1) newRecord.address.address1 = licenseData.address1;
            if (licenseData.city) newRecord.address.city = licenseData.city;
            if (licenseData.state) newRecord.address.state = licenseData.state;
            if (licenseData.zipCode) newRecord.address.zipCode = licenseData.zipCode;

            return { record: newRecord };
        }, () => {
            if (licenseData.zipCode) {
                this.decodeZip(licenseData.zipCode, 'address');
            }
        });
    }

    handleRedirect(record) {
        const { props: { getRedirectUrl, toggleCreateCustomer, history } } = this;

        if (getRedirectUrl) {
            const url = getRedirectUrl(record);
            history.push(url);
        } else if (toggleCreateCustomer) {
            toggleCreateCustomer();
        }
    }

    validateCustomerDuplicate() {
        const {
            record: { generalInfo: { firstName, lastName, cellPhone, homePhone, email } },
            createDespiteDuplicates,
        } = this.state;

        if (createDespiteDuplicates) {
            this.onSave();
            return;
        }

        const phone = cellPhone || homePhone;

        if (!firstName || (!lastName && !email && !phone)) {
            // Not enough info to confidently check duplicate, proceed to save.
            this.onSave();
            return;
        }

        this.setState({ loadingSuggestedCustomer: true, suggestedCustomer: null, createDespiteDuplicates: false });

        this.graphqlClient
            .query(CustomerQuery.GET_CUSTOMER_DUPLICATE_SEARCH, {
                firstName: firstName || null,
                lastName: lastName || null,
                phone: phone || null,
                email: email || null,
                customerId: null,
            })
            .then((response) => {
                if (response instanceof Error) {
                    ModalUtils.errorMessage(response?.graphQLErrors || [], response?.message || null);
                    this.setState({ loadingSuggestedCustomer: false });
                    this.onSave();
                    return;
                }
                const { data, graphQLErrors } = response;
                if (graphQLErrors && graphQLErrors.length > 0) {
                    ModalUtils.errorMessage(graphQLErrors);
                    this.setState({ loadingSuggestedCustomer: false });
                    this.onSave();
                    return;
                }

                if (data && data.getCustomerDuplicateSearch && data.getCustomerDuplicateSearch.length > 0) {
                    this.setState({
                        suggestedCustomer: data.getCustomerDuplicateSearch,
                        openModalSuggestedCustomer: true,
                        loadingSuggestedCustomer: false,
                    });
                } else {
                    this.setState({ loadingSuggestedCustomer: false });
                    this.onSave();
                }
            })
            .catch(() => {
                this.setState({ loadingSuggestedCustomer: false });
                this.onSave(); // Proceed even if duplicate check fails
            });
    }

    toggleCustomerSuggest() {
        this.setState({ openModalSuggestedCustomer: false });
    }

    onUseEnteredCustomer() {
        this.setState({
            openModalSuggestedCustomer: false,
            createDespiteDuplicates: true,
        }, () => {
            this.onSave();
        });
    }

    onUseSuggestedCustomer(customer) {
        this.setState({ openModalSuggestedCustomer: false }, () => {
            const { props: { onSetCustomer } } = this;
            if (onSetCustomer) {
                this.customerService.getCustomerAndAddress({ customerCode: customer.customerCode })
                    .then((response) => {
                        const { data, graphQLErrors } = response;
                        if (Array.isArray(graphQLErrors) && graphQLErrors.length > 0) {
                            ModalUtils.errorMessage(graphQLErrors);
                            return;
                        }
                        onSetCustomer(data);
                        this.handleRedirect(data);
                    })
                    .catch((error) => {
                        ModalUtils.errorMessage(error?.graphQLErrors || [], error?.message || null);
                    });
            } else {
                this.handleRedirect({ customerCode: customer.customerCode });
            }
        });
    }

    onSave() {
        const {
            state: { record, suggestedCustomer, createDespiteDuplicates },
            props: { onSetCustomer, onlyRequireGeneralInfo },
        } = this;

        delete record.address?.listCity;
        delete record.employment?.listCity;

        if (StringUtils.isEmpty(record.generalInfo.email)) record.generalInfo.email = null;

        const potentialDuplicateCustomerCodes = createDespiteDuplicates && suggestedCustomer
            ? (Array.isArray(suggestedCustomer) ? suggestedCustomer : [suggestedCustomer])
                .map((customer) => customer.customerCode)
                .filter(Boolean)
            : [];

        const input = onlyRequireGeneralInfo ? {
            generalInfo: {
                ...record.generalInfo,
                dob: DateUtils.getOnlyDate(record.generalInfo?.dob),
            },
        } : {
            generalInfo: {
                ...record.generalInfo,
                dob: DateUtils.getOnlyDate(record.generalInfo?.dob),
            },
            address: record.address,
            employment: record.employment,
        };

        if (potentialDuplicateCustomerCodes.length > 0) {
            input.potentialDuplicateCustomerCodes = potentialDuplicateCustomerCodes;
        }

        this.customerService.createFullCustomer(input)
            .then((response) => {
                const { data, graphQLErrors } = response;

                if (graphQLErrors) {
                    ModalUtils.errorMessage(graphQLErrors);

                    return;
                }

                if (data && data.createFullCustomer) {
                    this.setState({
                        suggestedCustomer: null,
                        createDespiteDuplicates: false,
                    });
                    const { createFullCustomer: { customerCode } } = data;
                    if (onSetCustomer) {
                        this.customerService.getCustomerAndAddress({ customerCode })
                            .then((response) => {
                                const { data, graphQLErrors } = response;
                                if (graphQLErrors) {
                                    ModalUtils.errorMessage(graphQLErrors);

                                    return;
                                }
                                onSetCustomer(data);
                                this.handleRedirect(data);
                            });
                    } else {
                        this.handleRedirect({ customerCode });
                    }
                }
            });
    }

    decodeZip(zip = '', section) {
        const input = {
            zip,
        };

        this.setState({ isDecodingZip: true });
        this.graphqlClient
            .query(CustomerQuery.DECODE_ZIP_CODE, input)
            .then((response) => {
                const { data, graphQLErrors } = response;

                if (graphQLErrors) {
                    ModalUtils.errorMessage(graphQLErrors);
                    return;
                }

                if (data?.decodeZip) {
                    const { decodeZip } = data;
                    const listCity = decodeZip.map((item) => CustomerMap.mapCity(item));
                    if (listCity.length > 1) listCity.unshift({ label: 'None', value: '' });
                    const zipData = decodeZip;

                    this.setState(({ record, isDecoderEnabled }) => {
                        if (isDecoderEnabled) {
                            const newRecord = { ...record };
                            newRecord[section].city = '';
                            newRecord[section].county = '';
                            newRecord[section].state = '';
                            newRecord[section].listCity = listCity;
                            return {
                                listCity, zipData, record: newRecord, isDecodingZip: false,
                            };
                        }
                        return { listCity, zipData, isDecodingZip: false };
                    });

                    if (decodeZip.length === 1) {
                        const currentData = decodeZip[0];

                        this.setState(({ record }) => {
                            const newRecord = { ...record };
                            newRecord[section].city = currentData.city;
                            newRecord[section].county = currentData.county;
                            newRecord[section].state = currentData.state;

                            return { record: newRecord };
                        });
                    }
                }
            });
    }

    onChangeCity(field, value, section = 'address') {
        this.setState(({ record, zipData }) => {
            const newRecord = { ...record };
            if (zipData && zipData.length > 0) {
                const alreadyExist = zipData.find((ele) => StringUtils.toUpperCase(ele.city) === StringUtils.toUpperCase(value));
                if (!alreadyExist) {
                    const newData = clone(zipData[0]);
                    newData.city = value;
                    zipData.unshift(newData);
                }
            }

            const countyAndState = ZipUtils.getCountryAndStateByCity(value, zipData);
            newRecord[section].city = value;
            if (!StringUtils.isEmpty(countyAndState.county)) newRecord[section].county = countyAndState.county;
            if (!StringUtils.isEmpty(countyAndState.state)) newRecord[section].state = countyAndState.state;

            return { record: newRecord };
        });
    }

    getInitState() {
        return {
            generalInfo: {
                firstName: '',
                middleName: '',
                lastName: '',
                dob: null,
                ssn: '',
                dln: '',
                email: null,
                cellPhone: '',
                workPhone: '',
                homePhone: '',
                isBusiness: false,
                isTaxable: true,
            },
            address: {
                address1: '',
                address2: '',
                city: '',
                state: '',
                county: '',
                zipCode: '',
                country: DefaultCountry.COUNTRY,
                start: '',
                end: null,
                mortgageOrRent: null,
                housingStatus: '',
                phone: '',
                listCity: [],
                action: '',
            },
            employment: {
                employer: '',
                title: '',
                workPhone: '',
                monthlyIncome: null,
                otherIncomeMonthly: 0,
                otherIncomeSource: '',
                end: null,
                start: '',
                isCurrentEmployment: true,
                address1: '',
                address2: '',
                zipCode: null,
                city: '',
                county: '',
                state: '',
                country: DefaultCountry.COUNTRY,
                listCity: [],
            },
        };
    }

    initBind() {
        this.onSave = this.onSave.bind(this);
        this.decodeZip = this.decodeZip.bind(this);
        this.onChangeCity = this.onChangeCity.bind(this);
        this.onChangeValue = this.onChangeValue.bind(this);
        this.validateCustomerDuplicate = this.validateCustomerDuplicate.bind(this);
        this.onEnableDecoder = this.onEnableDecoder.bind(this);
        this.handleRedirect = this.handleRedirect.bind(this);
        this.toggleCustomerSuggest = this.toggleCustomerSuggest.bind(this);
        this.onUseEnteredCustomer = this.onUseEnteredCustomer.bind(this);
        this.onUseSuggestedCustomer = this.onUseSuggestedCustomer.bind(this);
        this.onChangeLicenseData = this.onChangeLicenseData.bind(this);
    }

    render() {
        const { props, state } = this;

        return (
            <WrappedComponent
                {...props}
                {...state}
                decodeZip={this.decodeZip}
                onChangeCity={this.onChangeCity}
                onChangeValue={this.onChangeValue}
                onEnableDecoder={this.onEnableDecoder}
                toggleCustomerSuggest={this.toggleCustomerSuggest}
                onUseEnteredCustomer={this.onUseEnteredCustomer}
                onUseSuggestedCustomer={this.onUseSuggestedCustomer}
                onChangeLicenseData={this.onChangeLicenseData}
                onlyRequireGeneralInfo={props.onlyRequireGeneralInfo}
                validateCustomerDuplicate={this.validateCustomerDuplicate}
            />
        );
    }
};

CreateCustomerContainer.propTypes = {
    toggleCreateCustomer: PropTypes.func,
    onSetCustomer: PropTypes.func,
    onlyRequireGeneralInfo: PropTypes.bool,
    getRedirectUrl: PropTypes.func,
    history: PropTypes.object,
};

CreateCustomerContainer.defaultProps = {
    toggleCreateCustomer: null,
    onSetCustomer: null,
    onlyRequireGeneralInfo: false,
    getRedirectUrl: null,
    history: null,
};

export default CreateCustomerContainer;
